import SectionLink from '../../../components/SectionLink';
import { BUSINESS, SERVICE_AREAS } from '../../../site';
import { SERVICES } from '../../../data/services';

// Falmouth and Locust Grove share pages with Stafford and Spotsylvania, so list each page once.
const areaPages = SERVICE_AREAS.filter((area, i) => !area.href.includes('#') && SERVICE_AREAS.findIndex((a) => a.href === area.href) === i);

export default function Footer() {
  return (
    <footer className="text-white" style={{ background: 'linear-gradient(160deg,#161a20,#0e1116)' }}>
      <div className="max-w-7xl mx-auto px-6 pt-20">
        <div className="grid gap-12 pb-14" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
          {/* Company Info */}
          <div>
            <img
              src="/logo.webp"
              alt="Flip Ready Cleaning Services logo"
              width={223}
              height={129}
              loading="lazy"
              className="mb-[18px]"
              style={{ height: '129px', width: '223px' }}
            />
            <p className="text-[#9aa2ad] leading-relaxed text-[15px] mb-[22px]">
              Professional office and commercial cleaning services. Making workspaces spotless since 2010.
            </p>
            <p className="text-[13.5px] font-bold text-[#c3c9d1] mb-1.5">Based in:</p>
            <p className="text-sm text-[#9aa2ad] leading-relaxed">{BUSINESS.address.city}, {BUSINESS.address.state}<br />Serving the Fredericksburg region &amp; Northern Virginia</p>
          </div>

          {/* Quick Links */}
          <div>
            <h2 className="text-base font-bold mb-[18px]">Quick Links</h2>
            <div className="flex flex-col gap-3">
              <SectionLink section="services" className="text-[#9aa2ad] hover:text-white text-[14.5px]">Services</SectionLink>
              <SectionLink section="why-choose-us" className="text-[#9aa2ad] hover:text-white text-[14.5px]">About Us</SectionLink>
              {/* Restore with the testimonials section: <SectionLink section="reviews" ...>Reviews</SectionLink> */}
              <SectionLink section="contact" className="text-[#9aa2ad] hover:text-white text-[14.5px]">Contact</SectionLink>
              <SectionLink section="contact" className="text-[#9aa2ad] hover:text-white text-[14.5px]">Book Now</SectionLink>
            </div>
          </div>

          {/* Services */}
          <div>
            <h2 className="text-base font-bold text-white mb-[18px]">Services</h2>
            <div className="flex flex-col gap-3">
              {SERVICES.map((service) => (
                <SectionLink key={service.title} section="services" className="text-[#9aa2ad] hover:text-white text-[14.5px]">{service.title}</SectionLink>
              ))}
            </div>
          </div>

          {/* Service Areas */}
          <div>
            <h2 className="text-base font-bold text-white mb-[18px]">Service Areas</h2>
            <div className="flex flex-col gap-3">
              {areaPages.map((area) => (
                <a key={area.href} href={area.href} className="text-[#9aa2ad] hover:text-white text-[14.5px]">{area.linkText}</a>
              ))}
            </div>
          </div>

          {/* Get In Touch */}
          <div>
            <h2 className="text-base font-bold mb-[18px]">Get In Touch</h2>
            <div className="flex flex-col gap-4">
              <a href={BUSINESS.phoneHref} className="flex items-center gap-2.5 text-[#9aa2ad] hover:text-white text-[15px] font-bold">
                <i className="ri-phone-fill" style={{ color: '#5FA42B' }}></i>{BUSINESS.phoneDisplay}
              </a>
              <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2.5 text-[#9aa2ad] hover:text-white text-[14.5px]">
                <i className="ri-mail-fill" style={{ color: '#5FA42B' }}></i>{BUSINESS.email}
              </a>
              <div>
                <p className="text-[13.5px] font-bold text-[#c3c9d1] mb-1.5">Hours</p>
                <p className="text-sm text-[#9aa2ad] leading-relaxed">{BUSINESS.hours.label}<br />{BUSINESS.hours.time}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-8 flex flex-wrap items-center justify-between gap-5">
          {/* Social icons hidden until social links exist (all hrefs are "#")
          <div className="flex gap-4">
            <a href="#" aria-label="Facebook" className="text-[#9aa2ad] hover:text-white"><i className="ri-facebook-fill text-[19px]"></i></a>
            <a href="#" aria-label="Instagram" className="text-[#9aa2ad] hover:text-white"><i className="ri-instagram-fill text-[19px]"></i></a>
            <a href="#" aria-label="Google" className="text-[#9aa2ad] hover:text-white"><i className="ri-google-fill text-[19px]"></i></a>
          </div>
          */}
          <p className="text-[13.5px] text-[#7d848d]">© 2026 Flip Ready. All rights reserved.</p>
          {/* Legal links hidden until the pages exist (all hrefs are "#")
          <div className="flex gap-6">
            <a href="#" className="text-[13.5px] text-[#9aa2ad] hover:text-white">Privacy Policy</a>
            <a href="#" className="text-[13.5px] text-[#9aa2ad] hover:text-white">Terms of Service</a>
          </div>
          */}
        </div>
      </div>
    </footer>
  );
}
